import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=4cb7606e&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=4cb7606e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7606e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AlertBanner.vue
// module id = 169
// module chunks = 0